// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapping-flow {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding-bottom: 40px;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
}

/* KPI cards always fill the content width (no empty 4th column) */
.mapping-flow .detail-kpi-grid,
.mapping-flow .detail-kpi-grid--2,
.mapping-flow .detail-kpi-grid--3,
.mapping-flow .detail-kpi-grid--4,
.mapping-flow .detail-kpi-grid--5,
.mapping-flow .detail-kpi-grid--6 {
  width: 100%;
  align-items: stretch;
  grid-template-columns: repeat(auto-fit, minmax(168px, 1fr));
}

/* Keep analysis / dense grids on a stable column count */
.mapping-flow .detail-kpi-grid--3,
.mapping-flow .detail-kpi-grid--6 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 900px) {
  .mapping-flow .detail-kpi-grid--3,
  .mapping-flow .detail-kpi-grid--6 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .mapping-flow .detail-kpi-grid--3,
  .mapping-flow .detail-kpi-grid--6 {
    grid-template-columns: 1fr;
  }
}

.mapping-flow .fw-source-bar {
  width: 100%;
  box-sizing: border-box;
}

.mapping-flow .fw-source-bar .fw-stat {
  flex: 1 1;
  min-width: 0;
}

/* ——— Mapping stepper ——— */
.mapping-stepper {
  width: 100%;
  margin: 0 0 20px;
  padding: 14px 16px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);
}

.mapping-stepper-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
}

.mapping-stepper-item {
  position: relative;
  display: flex;
  align-items: stretch;
  min-width: 0;
}

.mapping-stepper-link {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
  padding: 6px 14px 6px 6px;
  text-decoration: none;
  color: inherit;
  border-radius: 10px;
  transition: background 0.14s;
}

.mapping-stepper-link:not(.is-static):hover {
  background: #f0faf8;
}

.mapping-stepper-link.is-static {
  cursor: default;
}

.mapping-stepper-index {
  flex: none;
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: #eef2f7;
  color: #8a9ba7;
  border: 1px solid #dfe7e8;
}

.mapping-stepper-item.is-active .mapping-stepper-index {
  background: #00146d;
  border-color: #00146d;
  color: #fff;
}

.mapping-stepper-item.is-done .mapping-stepper-index {
  background: #e1f4f0;
  border-color: #c5e4dc;
  color: #076b5c;
}

.mapping-stepper-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.mapping-stepper-meta {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8a9ba7;
}

.mapping-stepper-item.is-active .mapping-stepper-meta {
  color: #0d9b87;
}

.mapping-stepper-title {
  font-size: 14px;
  font-weight: 600;
  color: #5f7484;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mapping-stepper-item.is-active .mapping-stepper-title {
  color: #0b1e2d;
}

.mapping-stepper-item.is-done .mapping-stepper-title {
  color: #0b1e2d;
}

.mapping-stepper-connector {
  display: none;
}

@media (max-width: 960px) {
  .mapping-stepper-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
}

@media (max-width: 560px) {
  .mapping-stepper-list {
    grid-template-columns: 1fr;
  }

  .mapping-stepper-title {
    white-space: normal;
  }
}

.mapping-flow-hint {
  margin: 0 0 16px;
  color: #5f7484;
  font-size: 14.5px;
  line-height: 1.5;
  max-width: 72ch;
}

/* Context + table live inside ListPageShell as one composition */
.mapping-flow-shell-body {
  padding: 0;
}

.mapping-flow-shell-body .mapping-flow-context {
  margin: 0;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-top: none;
  background: #f7fafa;
}

.mapping-flow-shell-body .incyia-table-wrap {
  margin: 0;
  border: none;
  border-radius: 0;
}

.mapping-flow-row-cta {
  display: inline-flex !important;
  align-items: center;
  gap: 2px;
  width: auto !important;
  min-width: 28px;
  height: 28px;
  padding: 0 6px !important;
  color: #076b5c !important;
  font-family: Lato, sans-serif;
}

.mapping-flow-row-cta-label {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  color: #076b5c;
}

.incyia-table tbody tr:hover .mapping-flow-row-cta-label {
  color: #055447;
}

@media (max-width: 640px) {
  .mapping-flow-row-cta-label {
    display: none;
  }
}

.mapping-flow-callout {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  margin-bottom: 16px;
  border: 1px solid #cfe8e3;
  border-left: 4px solid #0d9b87;
  border-radius: 10px;
  background: linear-gradient(90deg, #f0faf8 0%, #fff 75%);
}

.mapping-flow-step {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border-radius: 10px;
  background: #e1f4f0;
  color: #076b5c;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.mapping-flow-callout strong {
  display: block;
  margin-bottom: 2px;
  color: #0b1e2d;
  font-size: 14px;
}

.mapping-flow-callout p {
  margin: 0;
  color: #5f7484;
  font-size: 13.5px;
  line-height: 1.45;
}

.mapping-progress {
  min-width: 220px;
  margin-left: auto;
}

.mapping-progress-meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
  color: #5f7484;
  font-size: 12px;
  font-weight: 700;
}

.mapping-progress-track {
  height: 7px;
  overflow: hidden;
  border-radius: 99px;
  background: #dfe7e8;
}

.mapping-progress-bar {
  height: 100%;
  border-radius: inherit;
  background: #0d9b87;
  transition: width 0.25s ease;
}

.mapping-progress-hint {
  margin: 8px 0 0;
  color: #5f7484;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 500;
}

.mapping-flow-grid-wrap {
  width: 100%;
}

.mapping-flow-grid {
  width: 100%;
}

/* Tables inside mapping accordions should edge-to-edge like list pages */
.mapping-flow .detail-acc-body > .incyia-table-wrap,
.mapping-flow .detail-acc-body > .mapping-flow-grid-wrap {
  margin: 0;
}

.mapping-flow .detail-acc-inner:has(.incyia-table-wrap),
.mapping-flow .detail-acc-inner:has(.mapping-flow-grid-wrap) {
  padding: 0;
}

.mapping-matrix-section {
  padding: 16px 18px 18px;
}

@media (max-width: 760px) {
  .mapping-flow-callout {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .mapping-progress {
    width: 100%;
    min-width: 0;
    margin-left: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/RelatedControls/MappingFlow.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,kEAAkE;AAClE;;;;;;EAME,WAAW;EACX,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA,yDAAyD;AACzD;;EAEE,gDAAgD;AAClD;;AAEA;EACE;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gDAAgD;IAChD,QAAQ;EACV;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,yEAAyE;AACzE;;EAEE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".mapping-flow {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding-bottom: 40px;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n}\n\n/* KPI cards always fill the content width (no empty 4th column) */\n.mapping-flow .detail-kpi-grid,\n.mapping-flow .detail-kpi-grid--2,\n.mapping-flow .detail-kpi-grid--3,\n.mapping-flow .detail-kpi-grid--4,\n.mapping-flow .detail-kpi-grid--5,\n.mapping-flow .detail-kpi-grid--6 {\n  width: 100%;\n  align-items: stretch;\n  grid-template-columns: repeat(auto-fit, minmax(168px, 1fr));\n}\n\n/* Keep analysis / dense grids on a stable column count */\n.mapping-flow .detail-kpi-grid--3,\n.mapping-flow .detail-kpi-grid--6 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 900px) {\n  .mapping-flow .detail-kpi-grid--3,\n  .mapping-flow .detail-kpi-grid--6 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .mapping-flow .detail-kpi-grid--3,\n  .mapping-flow .detail-kpi-grid--6 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.mapping-flow .fw-source-bar {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.mapping-flow .fw-source-bar .fw-stat {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n/* ——— Mapping stepper ——— */\n.mapping-stepper {\n  width: 100%;\n  margin: 0 0 20px;\n  padding: 14px 16px;\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);\n}\n\n.mapping-stepper-list {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  width: 100%;\n}\n\n.mapping-stepper-item {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  min-width: 0;\n}\n\n.mapping-stepper-link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n  padding: 6px 14px 6px 6px;\n  text-decoration: none;\n  color: inherit;\n  border-radius: 10px;\n  transition: background 0.14s;\n}\n\n.mapping-stepper-link:not(.is-static):hover {\n  background: #f0faf8;\n}\n\n.mapping-stepper-link.is-static {\n  cursor: default;\n}\n\n.mapping-stepper-index {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: #eef2f7;\n  color: #8a9ba7;\n  border: 1px solid #dfe7e8;\n}\n\n.mapping-stepper-item.is-active .mapping-stepper-index {\n  background: #00146d;\n  border-color: #00146d;\n  color: #fff;\n}\n\n.mapping-stepper-item.is-done .mapping-stepper-index {\n  background: #e1f4f0;\n  border-color: #c5e4dc;\n  color: #076b5c;\n}\n\n.mapping-stepper-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.mapping-stepper-meta {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.mapping-stepper-item.is-active .mapping-stepper-meta {\n  color: #0d9b87;\n}\n\n.mapping-stepper-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #5f7484;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mapping-stepper-item.is-active .mapping-stepper-title {\n  color: #0b1e2d;\n}\n\n.mapping-stepper-item.is-done .mapping-stepper-title {\n  color: #0b1e2d;\n}\n\n.mapping-stepper-connector {\n  display: none;\n}\n\n@media (max-width: 960px) {\n  .mapping-stepper-list {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n  }\n}\n\n@media (max-width: 560px) {\n  .mapping-stepper-list {\n    grid-template-columns: 1fr;\n  }\n\n  .mapping-stepper-title {\n    white-space: normal;\n  }\n}\n\n.mapping-flow-hint {\n  margin: 0 0 16px;\n  color: #5f7484;\n  font-size: 14.5px;\n  line-height: 1.5;\n  max-width: 72ch;\n}\n\n/* Context + table live inside ListPageShell as one composition */\n.mapping-flow-shell-body {\n  padding: 0;\n}\n\n.mapping-flow-shell-body .mapping-flow-context {\n  margin: 0;\n  border-radius: 0;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  background: #f7fafa;\n}\n\n.mapping-flow-shell-body .incyia-table-wrap {\n  margin: 0;\n  border: none;\n  border-radius: 0;\n}\n\n.mapping-flow-row-cta {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 2px;\n  width: auto !important;\n  min-width: 28px;\n  height: 28px;\n  padding: 0 6px !important;\n  color: #076b5c !important;\n  font-family: Lato, sans-serif;\n}\n\n.mapping-flow-row-cta-label {\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #076b5c;\n}\n\n.incyia-table tbody tr:hover .mapping-flow-row-cta-label {\n  color: #055447;\n}\n\n@media (max-width: 640px) {\n  .mapping-flow-row-cta-label {\n    display: none;\n  }\n}\n\n.mapping-flow-callout {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  margin-bottom: 16px;\n  border: 1px solid #cfe8e3;\n  border-left: 4px solid #0d9b87;\n  border-radius: 10px;\n  background: linear-gradient(90deg, #f0faf8 0%, #fff 75%);\n}\n\n.mapping-flow-step {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  border-radius: 10px;\n  background: #e1f4f0;\n  color: #076b5c;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.mapping-flow-callout strong {\n  display: block;\n  margin-bottom: 2px;\n  color: #0b1e2d;\n  font-size: 14px;\n}\n\n.mapping-flow-callout p {\n  margin: 0;\n  color: #5f7484;\n  font-size: 13.5px;\n  line-height: 1.45;\n}\n\n.mapping-progress {\n  min-width: 220px;\n  margin-left: auto;\n}\n\n.mapping-progress-meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 6px;\n  color: #5f7484;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.mapping-progress-track {\n  height: 7px;\n  overflow: hidden;\n  border-radius: 99px;\n  background: #dfe7e8;\n}\n\n.mapping-progress-bar {\n  height: 100%;\n  border-radius: inherit;\n  background: #0d9b87;\n  transition: width 0.25s ease;\n}\n\n.mapping-progress-hint {\n  margin: 8px 0 0;\n  color: #5f7484;\n  font-size: 12px;\n  line-height: 1.4;\n  font-weight: 500;\n}\n\n.mapping-flow-grid-wrap {\n  width: 100%;\n}\n\n.mapping-flow-grid {\n  width: 100%;\n}\n\n/* Tables inside mapping accordions should edge-to-edge like list pages */\n.mapping-flow .detail-acc-body > .incyia-table-wrap,\n.mapping-flow .detail-acc-body > .mapping-flow-grid-wrap {\n  margin: 0;\n}\n\n.mapping-flow .detail-acc-inner:has(.incyia-table-wrap),\n.mapping-flow .detail-acc-inner:has(.mapping-flow-grid-wrap) {\n  padding: 0;\n}\n\n.mapping-matrix-section {\n  padding: 16px 18px 18px;\n}\n\n@media (max-width: 760px) {\n  .mapping-flow-callout {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .mapping-progress {\n    width: 100%;\n    min-width: 0;\n    margin-left: 48px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
